<template>
    <div class="item-box item-head-box">
        {{ title }} 
    </div>
</template>

<script>
export default {
    props: {
        title: ''
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ItemHeadBox.vue